import { get } from 'lodash-es'

export const getUserData = state => get(state, 'auth.userData')
